import { render, staticRenderFns } from "./CourseSelect.vue?vue&type=template&id=18b16d5e&scoped=true&"
import script from "./CourseSelect.vue?vue&type=script&lang=js&"
export * from "./CourseSelect.vue?vue&type=script&lang=js&"
import style0 from "./CourseSelect.vue?vue&type=style&index=0&id=18b16d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b16d5e",
  null
  
)

export default component.exports